import { BoolAnswerText } from '@webapp/common/lib/ui';

import type { QuestionActor } from '@webapp/survey/src/machine/question-machine';

import type { AnswersRequest } from '../queries-api';

import { QuestionSimpleApi } from './common/simple';

export class AgreementApi extends QuestionSimpleApi {
    public query(actor: QuestionActor): AnswersRequest {
        const { answersActors, id, responseActor } = actor.getSnapshot().context;
        const { comment, value } = responseActor.getSnapshot().context;
        const checked = Boolean(value);
        const responseId = (() => {
            if (checked) {
                return answersActors
                    .find((actor) => actor.getSnapshot().context.value[0] === BoolAnswerText.TRUE)
                    ?.getSnapshot().context.id;
            }

            return answersActors
                .find((actor) => actor.getSnapshot().context.value[0] === BoolAnswerText.FALSE)
                ?.getSnapshot().context.id;
        })();

        return {
            question: id,
            data: [
                {
                    bool: checked,
                    answer: responseId,
                    comment,
                },
            ],
            comment,
        };
    }
}
